module.exports = require('./childrenPropType')
